import CustomButton from 'Components/CustomButton/CustomButton'
import CustomDialog from 'Components/CustomDialog/CustomDialog'
import { LinearProgress } from '@mui/material'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'
import type { FC } from 'react'
import { t } from 'ttag'

const SaveDialog: FC<{
  open: boolean
  handleClose: () => void
  handleSubmit: () => void
  loading: boolean
  title: string
  children: React.ReactNode
}> = ({ open, handleClose, handleSubmit, loading, title, children }) => {
  const theme = useTheme()

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <DialogContent>{loading ? <LinearProgress /> : children}</DialogContent>
      <DialogActions>
        <Button
          sx={{ color: theme.palette.text.primary }}
          onClick={handleClose}
        >{t`Cancel`}</Button>
        <CustomButton onClick={handleSubmit} disabled={loading} autoFocus>
          {t`Save`}
        </CustomButton>
      </DialogActions>
    </CustomDialog>
  )
}

export default SaveDialog
